<template>
  <div class="great-event-mobile-container">
    <!-- 筛选栏 -->
    <div class="filter-container">
      <el-form :inline="false" :model="listQuery" class="form-inline">
        <el-form-item label="人物">
          <el-input v-model="listQuery.person" placeholder="请输入人物名称" clearable />
        </el-form-item>
        <el-form-item>
          <div class="filter-buttons">
            <el-button type="primary" @click="handleFilter" class="filter-btn">查询</el-button>
            <el-button type="primary" @click="handleCreate" class="create-btn">新增</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 移动端卡片列表 -->
    <div class="card-list" v-loading="loading">
      <div 
        v-for="(item, index) in list" 
        :key="item.id" 
        class="event-card"
      >
        <div class="card-header">
          <div class="event-index">#{{ index + 1 }}</div>
          <div class="event-time">{{ formatTime(item.event_time) }}</div>
        </div>
        
        <div class="card-content">
          <div class="person-name">
            <i class="el-icon-user"></i>
            {{ item.person }}
          </div>
          <div class="event-content">{{ item.event }}</div>
          <div class="add-time">
            <span class="label">添加时间:</span>
            <span class="value">{{ formatTime(item.add_time) }}</span>
          </div>
        </div>
        
        <div class="card-actions">
          <el-button 
            size="mini" 
            type="primary" 
            @click="handleUpdate(item)"
            class="action-btn"
          >
            编辑
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="handleDelete(item)"
            class="action-btn"
          >
            删除
          </el-button>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-if="list.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无大事记数据</p>
      </div>
    </div>
    
    <!-- 编辑/新增对话框 -->
    <el-dialog 
      :title="dialogStatus === 'create' ? '新增大事记' : '编辑大事记'" 
      :visible.sync="dialogVisible" 
      width="90%"
      :close-on-click-modal="false"
      center
      append-to-body
      custom-class="mobile-dialog"
    >
      <el-form ref="dataForm" :model="temp" :rules="rules" label-position="top" label-width="100%">
        <el-form-item label="人物" prop="person">
          <el-input v-model="temp.person" placeholder="请输入人物名称" ref="personInput" />
        </el-form-item>
        <el-form-item label="事件时间" prop="event_time">
          <el-date-picker
            v-model="temp.event_time"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="事件内容" prop="event">
          <el-input v-model="temp.event" type="textarea" :rows="4" placeholder="请输入事件内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">取消</el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()" size="large">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGreatEvents, addGreatEvent, updateGreatEvent, deleteGreatEvent } from '@/api/great_event'
import { isMobile } from '@/utils/device'

export default {
  name: 'GreatEventMobile',
  data() {
    return {
      list: [], // 数据列表
      loading: false, // 加载状态
      dialogVisible: false, // 对话框可见性
      dialogStatus: '', // 对话框状态 create/update
      listQuery: { // 查询参数
        page: 1,
        size: 50, // 移动端增加每页数量，减少分页
        person: ''
      },
      temp: { // 临时数据，用于新增/编辑
        id: undefined,
        person: '',
        event_time: '',
        event: ''
      },
      rules: { // 表单验证规则
        person: [
          { required: true, message: '请输入人物名称', trigger: 'blur' }
        ],
        event_time: [
          { required: true, message: '请选择事件时间', trigger: 'change' }
        ],
        event: [
          { required: true, message: '请输入事件内容', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 格式化时间显示
    formatTime(timeStr) {
      if (!timeStr) return '未设置'
      const date = new Date(timeStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    // 获取数据列表
    getList() {
      this.loading = true
      getGreatEvents(this.listQuery).then(response => {
        this.list = response.data.records
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    
    // 处理查询
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    
    // 重置表单
    resetTemp() {
      this.temp = {
        id: undefined,
        person: '',
        event_time: '',
        event: ''
      }
    },
    
    // 处理新增
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        // 自动聚焦到人物输入框
        setTimeout(() => {
          this.$refs.personInput && this.$refs.personInput.focus()
        }, 100)
      })
    },
    
    // 新增数据
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          addGreatEvent(this.temp).then(response => {
            this.list.unshift(response.data)
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '新增成功!'
            })
            this.getList() // 重新加载数据
          })
        }
      })
    },
    
    // 处理编辑
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // 复制一份，防止修改原数据
      this.dialogStatus = 'update'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        // 自动聚焦到人物输入框
        setTimeout(() => {
          this.$refs.personInput && this.$refs.personInput.focus()
        }, 100)
      })
    },
    
    // 更新数据
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updateGreatEvent(tempData.id, tempData).then(() => {
            const index = this.list.findIndex(v => v.id === this.temp.id)
            this.list.splice(index, 1, tempData)
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '更新成功!'
            })
          })
        }
      })
    },
    
    // 处理删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGreatEvent(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList() // 重新加载数据
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.great-event-mobile-container {
  padding: 16px;
  min-height: 100vh;
  background-color: #f5f7fa;

  .filter-container {
    margin-bottom: 20px;
    background: #fff;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .form-inline {
      .el-form-item {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .filter-buttons {
        display: flex;
        gap: 12px;

        .filter-btn, .create-btn {
          flex: 1;
          height: 44px;
          font-size: 16px;
          border-radius: 8px;
        }
      }
    }
  }

  .card-list {
    .event-card {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #e4e7ed;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;

        .event-index {
          font-size: 16px;
          font-weight: 600;
          color: #409eff;
          background: #f0f9ff;
          padding: 4px 8px;
          border-radius: 4px;
        }

        .event-time {
          font-size: 14px;
          color: #909399;
        }
      }

      .card-content {
        margin-bottom: 16px;

        .person-name {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 12px;

          i {
            color: #409eff;
            margin-right: 8px;
            font-size: 20px;
          }
        }

        .event-content {
          font-size: 16px;
          color: #606266;
          line-height: 1.6;
          margin-bottom: 12px;
          word-break: break-all;
        }

        .add-time {
          display: flex;
          align-items: center;
          font-size: 14px;

          .label {
            color: #909399;
            margin-right: 8px;
          }

          .value {
            color: #606266;
          }
        }
      }

      .card-actions {
        display: flex;
        gap: 12px;

        .action-btn {
          flex: 1;
          height: 36px;
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: #909399;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }

  // 移动端对话框样式
  .mobile-dialog {
    .el-dialog {
      margin: 10vh auto !important;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

      .el-dialog__header {
        padding: 20px 20px 16px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        text-align: center;
      }

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }

      .el-dialog__body {
        padding: 20px;
      }

      .el-dialog__footer {
        padding: 16px 20px 20px;
        border-top: 1px solid #f0f0f0;
        text-align: center;

        .el-button {
          width: 45%;
          height: 44px;
          font-size: 16px;
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 480px) {
  .great-event-mobile-container {
    padding: 12px;

    .filter-container {
      padding: 12px;

      .form-inline .filter-buttons {
        gap: 8px;
      }
    }

    .card-list .event-card {
      padding: 12px;
      margin-bottom: 12px;

      .card-actions {
        gap: 8px;
        
        .action-btn {
          height: 40px;
        }
      }
    }
  }
}
</style> 